/**
 * Fork of LgyInputField for USWDS1+2
 *
 * @prettier
 * @author Alexander Nagelberg
 * (originally many authors)
 */
import React from 'react'
import MaskedInput from 'react-text-mask'
import LgyTooltip from '../lgy-tooltip/LgyTooltip'

import './inputfield.scss'

const getRandomInt = max => Math.floor(Math.random() * Math.floor(max))

/**
 *
 * @param {Object} props Properties
 * @param {Boolean} [props.required] If required, LgyFormSubmit will be disabled. Adds optional to label if not.
 * @param {Boolean} [props.mask] If set, masks the input
 * @param {String} [props.type] Sets input type. Default is text.
 * @param {String} [props.tooltip] Displays tooltip icon if set and shows message when hovered
 * @param {*} [props.prefix] If set, displays prefix for input (e.g. $)
 * @param {*} [props.suffix] If set, displays suffix for input (e.g. lbs)
 */
const LgyInputField = ({
  id,
  input,
  label,
  type,
  required,
  placeholder,
  autoFocus,
  maxLength,
  tooltip,
  meta: { touched, error, warning, dirty },
  mask,
  guide,
  prefix,
  suffix,
  disabled
}) => {
  const success = dirty && !error && !warning
  id = id || input.name + getRandomInt(100000)
  return (
    <div
      className={
        touched && error ? 'usa-input-error lgy-input-field usa-form-group--error' : 'lgy-input-field usa-form-group'
      }
    >
      {label && (
        <label htmlFor={id}>
          {label}
          {!required && <span className='usa-input-label-helper usa-hint'> (optional) </span>}
          {tooltip && <LgyTooltip message={tooltip} id={`${id}-tip`} />}
        </label>
      )}
      {touched && error && (
        <span className='usa-input-error-message usa-error-message' id={`${id}-error`} role='alert'>
          {error}
        </span>
      )}
      {touched && warning && (
        <span className='usa-error-message text-gold' role='alert'>
          {warning}
        </span>
      )}
      <div
        className={
          success
            ? 'usa-input-group usa-input-group--success'
            : error && touched
            ? 'usa-input-group usa-input-group--error'
            : 'usa-input-group'
        }
      >
        {prefix && (
          <div className='usa-input-prefix' aria-hidden={true}>
            {prefix}
          </div>
        )}
        {mask ? (
          <MaskedInput
            {...input}
            id={id}
            placeholder={placeholder ? placeholder : label}
            type={type}
            className={success ? 'usa-input' : error && touched ? 'usa-input usa-input--error' : 'usa-input'}
            aria-required={required}
            autoFocus={autoFocus}
            maxLength={maxLength}
            aria-describedby={error ? `${id}-error` : tooltip ? `${id}-tip` : ''}
            mask={mask}
            guide={guide}
            aria-invalid={!!touched && !!error}
            disabled={disabled}
          />
        ) : (
          <input
            {...input}
            id={id}
            placeholder={placeholder ? placeholder : label}
            type={type}
            className={success ? 'usa-input' : error && touched ? 'usa-input usa-input--error' : 'usa-input'}
            aria-required={required}
            autoFocus={autoFocus}
            maxLength={maxLength}
            aria-describedby={error ? `${id}-error` : tooltip ? `${id}-tip` : ''}
            aria-invalid={!!touched && !!error}
            disabled={disabled}
          />
        )}
        {suffix && (
          <div className='usa-input-suffix' aria-hidden={true}>
            {suffix}
          </div>
        )}
      </div>
    </div>
  )
}

export default LgyInputField
